import React from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../SEO";
import config from "../../config";

export default function PointPurchaseCanceled() {
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title="Payment Canceled — askTheSea"
        description="Your point purchase was canceled."
        url={`${config.BaseUrl}/points/canceled`}
        image={`${config.BaseUrl}/assets/logo.png?v=2`}
        noindex
      />
      <section className="page active" id="page-points-canceled">
        <div className="wrap" style={{ paddingTop: "60px" }}>
          <div className="purchase-result">
            <div className="result-icon">✕</div>
            <h1>Payment canceled</h1>
            <p className="result-detail">No charges were made. You can try again whenever you're ready.</p>
            <button type="button" className="btn btn-primary" onClick={() => navigate("/points")}>Back to points</button>
          </div>
        </div>
      </section>
    </>
  );
}
